import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const SiteMaintenance: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="m30.33 6.56-.32-.99-5.2 5.2-2.56-1.02-1.02-2.56 5.2-5.2-.98-.32a7.7 7.7 0 0 0-10.09 7.29c0 .95.17 1.87.52 2.76L2.19 25.4a3.1 3.1 0 0 0 0 4.4 3.1 3.1 0 0 0 4.41 0l13.68-13.67a7.69 7.69 0 0 0 10.05-9.57Z"
    />
  </Icon>
);
